/**
 * Recent content directive where you can view recent content.
 */
/* global $ */
import angular from 'angular';
import ComponentsModule from '../components-module';
import _ from 'lodash';
import template from './recent-content-list.html';

const COMPONENT_NAME = 'recentContentList';

const KeyboardKeys = Object.freeze({
  KEY_ENTER: 13,
  KEY_ESCAPE: 27,
  KEY_UP: 38,
  KEY_DOWN: 40,
  KEY_LEFT: 37,
  KEY_RIGHT: 39,

  KEY_F1: 112,
  KEY_F12: 123
});

const isIgnoreKeyCode = (keyCode) => {
  return (keyCode >= KeyboardKeys.KEY_F1 && keyCode <= KeyboardKeys.KEY_F12)
    || keyCode === KeyboardKeys.KEY_LEFT
    || keyCode === KeyboardKeys.KEY_RIGHT;
};

angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, ($rootScope, $translate, $sce, AuthenticationService, RecentContentService, ContentEditor, ErrorMessagingService, ClipboardService) => {
    return {
      restrict: 'AE',
      replace: true,
      template: template,

      controller: function ($scope, $element) {
        AuthenticationService.getCurrentUser()
          .then ((currentUser) => {
            $scope.thumbnailToken = '&token=' + currentUser.token;
          });

        $scope.selectedIndex = 0;
        $scope.copyInProgress = false;

        $scope.recentContent = _.filter(RecentContentService.getRecentContent(), function (content) {
          return $rootScope.contentInEdit !== content.id;
        });

        $scope.setMouseSelectionMode = (event) => {
          $($element).one('keydown', $scope.setKeyboardSelectionMode);

          $scope.selectionMode = 'msm';
          $(event.target).trigger('mouseover');
        };

        $scope.setKeyboardSelectionMode = () => {
          $($element).one('mousemove', $scope.setMouseSelectionMode);
          $scope.selectionMode = 'ksm';
        };

        $scope.onHover = (index) => {
          if ($scope.selectionMode === 'msm') {
            $scope.selectedIndex = index;
          }
        };

        $scope.navigate = function (content) {
          $scope.close();

          if (content.autosaved) {
            ContentEditor.editContent(content.id);
          } else {
            ContentEditor.openContent (content.id);
          }
        };

        $scope.highlight = function (text, search) {
          if (!search) {
            return $sce.trustAsHtml(text);
          }
          return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlight">$&</span>'));
        };

        $scope.handleKeys = ($event) => {
          // Left and right arrow keys will mess up the input find position, so let's prevent that.
          // Also prevent function keys.
          if (isIgnoreKeyCode($event.keyCode)) {
            $event.preventDefault();
            $event.stopImmediatePropagation();

            return false;
          }

          if ($event.keyCode === KeyboardKeys.KEY_ENTER) {
            $scope.navigate($scope.filteredRecentContent[$scope.selectedIndex]);
          } else if ($event.keyCode === KeyboardKeys.KEY_UP) {
            $scope.selectedIndex--;

            if ($scope.selectedIndex < 0) {
              $scope.selectedIndex = $scope.filteredRecentContent.length - 1;
            }
          } else if ($event.keyCode === KeyboardKeys.KEY_DOWN) {
            $scope.selectedIndex = ++$scope.selectedIndex % $scope.filteredRecentContent.length;
          } else if ($event.keyCode === KeyboardKeys.KEY_ESCAPE) {
            if ($scope.search && $scope.search.title) {
              $event.preventDefault();
              $event.stopPropagation();

              $scope.search.title = '';
            }
          }
        };

        $scope.copy = function (event, result) {
          $scope.copyInProgress = true;

          event.stopPropagation();
          event.preventDefault();

          ClipboardService.putInClipboard([
            {
              id: result.id,
              type: result.contentType
            }
          ]).catch(function (error) {
            console.warn('Error: Failed to copy content reference(s) into clipboard!', error);

            $(event.target).attr('title', $translate.instant('recent-content-list.copy.copy-failed.title'));
            $(event.target).tooltip({'trigger': 'manual', 'container': 'body'});
            $(event.target).tooltip('show');

            ErrorMessagingService.sendError(atex.aceui.error.Error({
              cause: 'Error: Failed to copy content reference(s) into clipboard!',
              severity: atex.aceui.error.severities.MINOR,
              origin: 'Recent Content List'
            }));

            setTimeout(function () {
              $(event.target).tooltip('destroy');
            }, 2000);
          }).then(function () {
            $scope.copyInProgress = false;
          });
        };
      },

      link: function (scope) {
        scope.setKeyboardSelectionMode();
      }
    };
  });

export default COMPONENT_NAME;
